export default function History() {
  const historyData = [
    {
      year: '2025',
      events: [
        { month: '01', description: '지역아동센터 후원 협약 체결' },
        { month: '01', description: '겨울나기 온정 캠페인 진행' }
      ]
    },
    {
      year: '2024',
      events: [
        { month: '12', description: '연말 사랑나눔 바자회 개최' },
        { month: '10', description: '독거노인 가정 방문 봉사활동' },
        { month: '08', description: '여름방학 교육지원 프로그램 운영' },
        { month: '06', description: '저소득층 의료비 지원 사업 시작' },
        { month: '03', description: '푸드뱅크 운영 확대' }
      ]
    },
    {
      year: '2023',
      events: [
        { month: '11', description: '지역사회 나눔 축제 개최' },
        { month: '09', description: '학습교구 지원 사업 시작' },
        { month: '05', description: '정기후원자 1,000명 돌파' },
        { month: '02', description: '기업 후원 파트너십 체결' }
      ]
    },
    {
      year: '2022',
      events: [
        { month: '12', description: '사단법인 유앤아이월드 설립' },
        { month: '12', description: '첫 번째 나눔 활동 시작' }
      ]
    }
  ];

  return (
    <section id="연혁" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            연혁
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            <strong>유앤아이월드</strong>의 발자취
          </h2>
          <p className="text-gray-600 text-lg">
            나눔과 봉사로 함께 걸어온 우리의 여정
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200 hidden lg:block"></div>

          {/* Timeline Items */}
          <div className="space-y-16">
            {historyData.map((yearData, yearIndex) => (
              <div key={yearData.year} className="relative">
                {/* Year Badge */}
                <div className="flex justify-center mb-8">
                  <div className="bg-blue-600 text-white px-8 py-3 rounded-full text-2xl font-bold shadow-lg z-10 relative">
                    {yearData.year}
                  </div>
                </div>

                {/* Events */}
                <div className="space-y-8">
                  {yearData.events.map((event, eventIndex) => (
                    <div
                      key={eventIndex}
                      className={`flex items-center gap-8 ${
                        eventIndex % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                      } flex-col lg:flex-row`}
                    >
                      {/* Left/Right Content */}
                      <div className={`flex-1 ${eventIndex % 2 === 0 ? 'lg:text-right' : 'lg:text-left'} text-center`}>
                        <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-1">
                          <div className="text-blue-600 font-bold text-lg mb-2">
                            {event.month}월
                          </div>
                          <p className="text-gray-900 font-medium text-lg">
                            {event.description}
                          </p>
                        </div>
                      </div>

                      {/* Center Dot */}
                      <div className="relative z-10 hidden lg:block">
                        <div className="w-6 h-6 bg-blue-600 rounded-full border-4 border-white shadow-lg"></div>
                      </div>

                      {/* Empty Space for alternating layout */}
                      <div className="flex-1 hidden lg:block"></div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
